import React, { useEffect } from 'react';

const TheTeam = () => {
  useEffect(() => {
    const observerOptions = {
      threshold: 0.2,
      rootMargin: '0px 0px -100px 0px'
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('animate-fade-in');
        }
      });
    }, observerOptions);

    const elements = document.querySelectorAll('.fade-on-scroll');
    elements.forEach(el => observer.observe(el));

    return () => observer.disconnect();
  }, []);

  return (
    <div className="w-full">
      {/* Hero */}
      <section className="min-h-[60vh] flex items-center justify-center bg-[#F5F1ED] relative overflow-hidden">
        <div className="absolute right-20 top-1/4 w-96 h-96 border border-[#A08872]/10 rounded-full"></div>
        <div className="container mx-auto px-6 py-20 relative z-10">
          <p className="text-sm text-[#8B7355] uppercase tracking-widest mb-4 fade-on-scroll opacity-0">ABOUT US</p>
          <h1 className="text-4xl sm:text-5xl md:text-7xl font-serif text-[#2A2A2A] mb-6 fade-on-scroll opacity-0">Leadership</h1>
        </div>
      </section>

      {/* Team Section */}
      <section className="py-20 bg-white">
        <div className="container mx-auto px-6 max-w-6xl">
          <h2 className="text-2xl sm:text-3xl md:text-5xl font-serif text-[#2A2A2A] mb-12 md:mb-16 fade-on-scroll opacity-0">The Team</h2>
          
          <div className="space-y-20">
            {/* Mr. Sanjay Negi */}
            <div className="fade-on-scroll opacity-0 border-l-4 border-[#8B7355] pl-8">
              <h3 className="text-3xl font-serif text-[#2A2A2A] mb-4">Mr. Sanjay Negi</h3>
              <p className="text-sm text-[#8B7355] uppercase tracking-widest mb-6">CO-FOUNDER</p>
              <div className="space-y-4 text-lg text-[#3D3D3D] leading-relaxed">
                <p>
                  Mr. Negi represents executional conviction. With extremely high risk tolerance balanced by deep introspection, he has led land aggregation strategies, structured negotiations, and capital positioning across multiple cycles.
                </p>
                <p>
                  Known for his resilience and ability to convert complex land situations into viable assets, he thrives on trust-based execution. His philanthropic orientation remains understated yet consistent, reflecting a belief that value creation extends beyond balance sheets.
                </p>
              </div>
            </div>

            {/* Mr. Manu Mittal */}
            <div className="fade-on-scroll opacity-0 border-l-4 border-[#8B7355] pl-8">
              <h3 className="text-3xl font-serif text-[#2A2A2A] mb-4">Mr. Manu Mittal</h3>
              <p className="text-sm text-[#8B7355] uppercase tracking-widest mb-6">CO-FOUNDER</p>
              <div className="space-y-4 text-lg text-[#3D3D3D] leading-relaxed">
                <p>
                  Mr. Mittal transitioned into real estate with a research-driven approach. His differentiation lies in intellectual curiosity and technical adaptability. An avid learner and technology enthusiast, he integrates data-backed thinking into geographic positioning, structured deal-making, and platform expansion.
                </p>
                <p>
                  His background enables the group to blend traditional real estate intelligence with modern analytical frameworks.
                </p>
              </div>
            </div>

            {/* Yagya Mittal */}
            <div className="fade-on-scroll opacity-0 border-l-4 border-[#A08872] pl-8">
              <h3 className="text-2xl font-serif text-[#2A2A2A] mb-4">Yagya Mittal</h3>
              <p className="text-sm text-[#8B7355] uppercase tracking-widest mb-6">INVESTMENT ANALYST</p>
              <div className="text-lg text-[#3D3D3D] leading-relaxed">
                <p>
                  Yagya brings analytical rigor and financial modeling expertise to the investment team, supporting deal evaluation and portfolio analysis across UK Stage's real estate platform.
                </p>
              </div>
            </div>

            {/* Akshit Negi */}
            <div className="fade-on-scroll opacity-0 border-l-4 border-[#A08872] pl-8">
              <h3 className="text-2xl font-serif text-[#2A2A2A] mb-4">Akshit Negi</h3>
              <p className="text-sm text-[#8B7355] uppercase tracking-widest mb-6">INVESTMENT ANALYST</p>
              <div className="text-lg text-[#3D3D3D] leading-relaxed">
                <p>
                  Akshit contributes to investment analysis and market research, helping identify and evaluate land acquisition opportunities across growth corridors.
                </p>
              </div>
            </div>

            {/* Siddharth Sharma */}
            <div className="fade-on-scroll opacity-0 border-l-4 border-[#A08872] pl-8">
              <h3 className="text-2xl font-serif text-[#2A2A2A] mb-4">Siddharth Sharma</h3>
              <p className="text-sm text-[#8B7355] uppercase tracking-widest mb-6">STRATEGIC PARTNERSHIPS LEAD</p>
              <div className="text-lg text-[#3D3D3D] leading-relaxed">
                <p>
                  Siddharth leads strategic partnership initiatives, building and maintaining relationships with investors, joint venture partners, and institutional stakeholders to support capital formation.
                </p>
              </div>
            </div>

            {/* Akshara Negi */}
            <div className="fade-on-scroll opacity-0 border-l-4 border-[#A08872] pl-8">
              <h3 className="text-2xl font-serif text-[#2A2A2A] mb-4">Akshara Negi</h3>
              <p className="text-sm text-[#8B7355] uppercase tracking-widest mb-6">STRATEGIC PARTNERSHIPS LEAD</p>
              <div className="text-lg text-[#3D3D3D] leading-relaxed">
                <p>
                  Akshara focuses on developing strategic alliances and partnership opportunities, working closely with stakeholders to drive business development and growth initiatives.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Complementary Forces */}
      <section className="py-20 bg-[#EDE8E3]">
        <div className="container mx-auto px-6 max-w-5xl text-center">
          <p className="text-xl sm:text-2xl md:text-3xl font-serif text-[#2A2A2A] leading-relaxed fade-on-scroll opacity-0">
            Together, the founders represent complementary forces: execution conviction and analytical discipline.
          </p>
        </div>
      </section>

      {/* Philanthropy Section */}
      <section className="py-20 bg-white">
        <div className="container mx-auto px-6 max-w-5xl">
          <h2 className="text-2xl sm:text-3xl md:text-5xl font-serif text-[#2A2A2A] mb-8 fade-on-scroll opacity-0">Community Impact</h2>
          <div className="space-y-6 text-lg text-[#3D3D3D] leading-relaxed">
            <p className="fade-on-scroll opacity-0">
              The founders are also part of the leadership of Lakshman Bharti Vidyalaya, an institution that was originally established as a government-operated school serving economically marginalized communities and is now privately managed under a trust structure.
            </p>
            <p className="fade-on-scroll opacity-0">
              The school focuses on providing accessible, structured education to students from underprivileged backgrounds, ensuring continuity, quality, and administrative stability.
            </p>
          </div>
          <div className="mt-8 fade-on-scroll opacity-0">
            <img 
              src="https://images.unsplash.com/flagged/photo-1574097656146-0b43b7660cb6?w=1000&q=80" 
              alt="Indian Education Initiative"
              className="w-full h-[220px] sm:h-[350px] md:h-[500px] object-cover rounded-lg"
            />
          </div>
        </div>
      </section>
    </div>
  );
};

export default TheTeam;